var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.filters,"item-text":"label","return-object":""},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }